export type NavKey = "clubhouse" | "tee-off" | "rivalry" | "feed" | "more";

const paths: Record<NavKey, string[]> = {
  clubhouse: ["M3 11 12 3l9 8", "M5 10v10h14V10", "M9.5 20v-5h5v5"],
  "tee-off": ["M6 21V3", "M6 4h11l-2.6 3L17 10H6"],
  rivalry: ["M4 4l9 9", "M20 4l-9 9", "M13 13l4 4", "M11 13l-4 4"],
  feed: ["M4 5h16v11H8l-4 3z"],
  more: [
    "M5 12h.01",
    "M12 12h.01",
    "M19 12h.01",
    "M5 12a.5.5 0 1 0 0 .01",
    "M12 12a.5.5 0 1 0 0 .01",
    "M19 12a.5.5 0 1 0 0 .01",
  ],
};

/** The five primary navigation glyphs. */
export function NavIcon({ name }: { name: NavKey }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "more" ? 2.6 : 1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
